export default function MAX() {
  return (
    <div className="p-4">
      <h1>MAX</h1>
    </div>
  );
}
